import { AbstractControl } from "@angular/forms";

export function passwordMatchValidator(control: AbstractControl) {
  const password: string = control.get("newPassword").value; // get password from our password form control
  const confirmPassword: string = control.get("newPasswordDuplicate").value; // get password from our confirmPassword form control
  // compare is the password math
  if (password !== confirmPassword) {
    // if they don't match, set an error in our confirmPassword form control
    control.get("newPasswordDuplicate").setErrors({ NoPassswordMatch: true });
  }
}



// WEBPACK FOOTER //
// ./src/app/validators/password-match-validator.directive.ts